import actionNames from './actionNames'

const mutations = {
  customAnalytics(state, customAnalytics) {
    state.customAnalytics = customAnalytics
  },

  publisher(state, publisher) {
    state.publisher = publisher
  },
  subId(state, subId) {
    state.subId = subId
  },
  team(state, team) {
    state.team = team
  },

  [actionNames.GET_PUBLISHER_REQUESTED](state) {
    state.isLoadingPublisher = true
    state.didLoadPublisher = false
  },
  [actionNames.GET_PUBLISHER_SUCCEEDED](state, publisher) {
    state.isLoadingPublisher = false
    state.publisher = publisher
  },
  [actionNames.GET_PUBLISHER_FAILED](state, error) {
    state.isLoadingPublisher = false
    state.didLoadPublisherFail = error || error === false ? error : true

    state.publisherViewStatus = 502
  },

  [actionNames.SHOW_PUBLISHER_VIEW](state, status) {
    state.isLoadingPublisher = false
    state.publisherViewStatus = status
  },

  currentRecord(state, currentRecord) {
    state.currentRecord = currentRecord
  },
}

export default mutations
